export default __webpack_public_path__ + "static/media/organisation-red.9bee08c4.svg";